export default "__VITE_ASSET__DgiLIZrp__"